"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncRetryableLazy = exports.Lazy = void 0;
/**
 * Handy class for managing asynchronous dependencies of classes.
 *
 * Will call the producer function once and only once when getValue is called,
 * returning the resultant value for every subsequent call.
 */
class Lazy {
    // eslint-disable-next-line
    constructor(producerFn) {
        this.producerFn = producerFn;
    }
    /**
     * Lazily get the value returned by the producer.
     * @returns The value returned from the producer function
     */
    getValue() {
        if (!this.value) {
            this.value = this.producerFn();
        }
        return this.value;
    }
}
exports.Lazy = Lazy;
/**
 * Handy class for managing asynchronous dependencies of classes.
 *
 * Will call asynchronous producer only after `getValue` is called.  If the
 * deferred code errors, we can try it again by re-calling `getValue` after
 * the promise rejects.
 */
class AsyncRetryableLazy {
    // eslint-disable-next-line
    constructor(producerFn) {
        this.producerFn = producerFn;
    }
    /**
     * Lazily get the value returned by the async producer.
     *
     * @returns The value returned from the producer function
     */
    async getValue() {
        if (!this.promise) {
            this.promise = this.producerFn().catch((e) => {
                delete this.promise;
                throw e;
            });
        }
        return this.promise;
    }
}
exports.AsyncRetryableLazy = AsyncRetryableLazy;
